import CommonContainer from "../../Container/CommonContainer";
import { FaToggleOn, FaToggleOff, FaPen } from "react-icons/fa";
import * as CaseOriginService from "../../../Services/Masters/CaseOrigin/CaseOriginService";
import toast from "react-hot-toast";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

const CaseOriginComponent = () =>{

    const { register, handleSubmit, formState: { errors }, reset, } = useForm();

    const [caseOriginList, setCaseOriginList] = useState([]);
    const [selectedCaseOrigin, setSelectedCaseOrigin] = useState({});
    const [newCaseOriginModal, setNewCaseOriginModal] = useState(false);

    const fetchAllCaseOriginMasterList = () => {
        CaseOriginService.GetCaseOriginList()
          .then(({ data }) => {
            if (data.IsSuccess) {
              setCaseOriginList(data.Data);
            }
          })
          .catch(() => toast.error("Something went wrong."));
    };

    useEffect(() => {
        fetchAllCaseOriginMasterList();
        if (caseOriginList.length > 0) {
          //console.log("Updated caseOriginList:", caseOriginList);
        }
    },[]);

    const onSubmit = (data) => {
      //debugger;
      if (selectedCaseOrigin?.CaseOriginId) {
        data.CaseOriginId = selectedCaseOrigin?.CaseOriginId;
        CaseOriginService.UpdateCaseOrigin(data)
          .then(({ data }) => {
            if (data.IsSuccess) {
              fetchAllCaseOriginMasterList();
              toast.success("Case Origin updated successfully!");
              handleNewCaseOriginModalClose();
            } else {
              toast.error("Something went wrong during update.");
            }
          })
          .catch(() => toast.error("Something went wrong during update."))
          .finally(() => { });
      } else {
        CaseOriginService.CreateNewCaseOrigin(data)
          .then(({ data }) => {
            if (data.IsSuccess) {
              fetchAllCaseOriginMasterList();
              toast.success("Case Origin saved successfully!");
              handleNewCaseOriginModalClose();
            } else {
              toast.error(data.ResponseMessage);
            }
          })
          .catch(() => toast.error("Something went wrong during creation."))
          .finally(() => { });
      }
    };

    const handleNewCaseOriginModalClose = () => {
      reset();
      setSelectedCaseOrigin([]);
      setNewCaseOriginModal(false)
    };

    const handleActivateDeActivateCaseOrigin = (rec) =>{
      CaseOriginService.ActivateDeActivateCaseOrigin(rec.CaseOriginId, !rec.Is_Active).then(data => {
        if (data.data.IsSuccess) {
          const message = rec.IsActive ? "Case Origin DeActivated Successfully" : "Case Origin Activated Successfully";
          toast.success(message);
          fetchAllCaseOriginMasterList();
        } else {
          toast.error("Somthing went wrong");
        }
        //console.log("data", data)
      }).catch(error => {
        toast.error("Somthing went wrong");
      })
    }

    const handleViewCaseOriginDetailById = (CaseOriginId) => {
      //debugger;
      const selectedItem = caseOriginList.find(item => item.CaseOriginId === CaseOriginId);
      if(selectedItem != null){
        setSelectedCaseOrigin(selectedItem);
        setNewCaseOriginModal(true);
      }
      else{
        setSelectedCaseOrigin({});
      }
    };

    return (
        <>
          {/* <LoadingSpinnerComponent></LoadingSpinnerComponent> */}
          <CommonContainer heading="Case Origin List" buttonText="Add Case Origin" onButtonClick={() => { reset(); setSelectedCaseOrigin([]); setNewCaseOriginModal(true) }}>
    
            <div className="d-flex align-items-center justify-content-between mb-2">
              <div className="d-flex align-items-center gap-2">
              </div>
              {/* <div className="search-box" style={{ position: "relative", width: "320px" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  //ref={selectedSearchUser}
                  style={{
                    paddingRight: "35px",
                    borderRadius: "5px",
                    border: "1px solid #ddd",
                  }}
                />
                <button
                  type="button"
                  className="btn btn-success d-flex align-items-center justify-content-center"
                  style={{
                    padding: '5px',
                    position: "absolute",
                    right: "0px",
                    height: "35px",
                    width: "45px",
                    top: "50%",
                    borderTopLeftRadius: "0",
                    borderBottomLeftRadius: "0",
                    transform: "translateY(-50%)",
                  }}
                  //onClick={fetchUniversalFilterUserData}
                >
                  <FaSearch />
                </button>
    
              </div> */}
            </div>
            <div>
              <div className="table-responsive" >
                <table className="table table-bordered custom-table" >
                  <thead>
                    <tr>
                      <th> Case Origin</th>
                      <th> Active </th>
                      <th> Action </th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      caseOriginList.length > 0 ? (
                        caseOriginList.map((rec, index) => (
                          <tr key={index} >
                            <td>{rec.CaseOrigin}</td >
                            <td>
                              {rec.Is_Active ? <FaToggleOn title="Deactivate CaseOrigin" onClick={() => handleActivateDeActivateCaseOrigin(rec)} color="green" size={16} /> : <FaToggleOff onClick={() => handleActivateDeActivateCaseOrigin(rec)} title="Activate CaseOrigin" color="red" size={16} />}
                            </td>
                            <td>
                              {/* <FaPenSquare color="green" className="mr-2 cursor-pointer" size={25} onClick={() => handleViewUserDetailById(rec.UserId)} title="Edit User" /> */}
                              <FaPen color="green" className="mr-2 cursor-pointer" onClick={() => handleViewCaseOriginDetailById(rec.CaseOriginId)} title="Edit CaseOrigin" />
                              {/* <FaTrash color={"red"} onClick={() => handleUserDelete(rec)} /> */}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr><td colSpan="9" className="text-center" > No Data found </td></tr >
                      )}
                  </tbody>
                </table>
              </div>
            </div>

            {newCaseOriginModal && (
            <div className="modal-backdrop">
              <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg custom-modal" role="document">
                  <div className="modal-content mb-0 p-0">
                    <div className="modal-header p-2-5">
                      <h5 className="modal-title">{selectedCaseOrigin?.CaseOrigin ? "Edit Case Origin" : "New Case Origin"}</h5>
                      <button type="button" className="btn-close" onClick={handleNewCaseOriginModalClose}></button>
                    </div>
                    <div className="modal-body p-1">
                      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                        <div className="container mb-0" style={{ fontSize: "13px" }}>

                          <div className="row">

                            <div className="col-md-4 mb-2">
                              <label className="fw-bold required mb-0-5">Case Origin</label>
                              <input type="text" className="form-control" placeholder="Enter Case Origin" {...register("CaseOrigin", { required: "Case Origin is required" })} defaultValue={selectedCaseOrigin?.CaseOrigin || ""} />
                              {errors.CaseOrigin && <p className="text-danger required_error">{errors.CaseOrigin.message}</p>}
                            </div>
                          </div>
                        </div>

                        <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                          <button type="button" className="btn btn-danger" onClick={handleNewCaseOriginModalClose}>Close</button>
                          <button type="submit" className="btn btn-primary">{selectedCaseOrigin?.CaseOriginId ? "Update" : "Save"}</button>
                        </div>

                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
    
          </CommonContainer >
        </>
      );
}

export default CaseOriginComponent